// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3RFVg","icon":"SortAdornment_icon__28Aww","up":"SortAdornment_up__1gjzc","down":"SortAdornment_down__30s0G","active":"SortAdornment_active__278EZ"};